import { useTheme } from '../contexts/ThemeContext'
import 'primeicons/primeicons.css'

export default function ContactSection() {
  const { theme } = useTheme()

  const handleZaloContact = () => {
    // Mở Zalo chat với số điện thoại trợ lý
    window.open('https://zalo.me/0703577789', '_blank')
  }

  return (
    <section className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-black' : 'bg-gray-100'}`}>
      <div className="container mx-auto text-center">
        <div className="max-w-2xl mx-auto space-y-6">
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
            Sẵn sàng bắt đầu hành trình của bạn?
          </h2>
          <p className={`text-base md:text-lg leading-relaxed ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
            Liên hệ ngay hôm nay để được tư vấn và trải nghiệm buổi tập thử<br />
            miễn phí
          </p>
          <div className="pt-4">
            <button
              onClick={handleZaloContact}
              className="px-8 py-4 md:px-10 md:py-4 bg-gold-gradient text-black font-bold text-lg md:text-xl rounded-lg shadow-lg shadow-gold-500/30 hover:shadow-xl hover:shadow-gold-500/50 transition-all duration-300 transform hover:scale-105 active:scale-95"
            >
              Liên hệ ngay
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

